import "./Product1.css"
import Star from "@material-ui/icons/Star"
import Halfstar from "@material-ui/icons/StarHalf"

import { useDispatch } from "react-redux"


export default function Product1({id,prdName,img,price,review,buttonCart,add}){
    let dispatch =useDispatch();

    return(

       
    
        <div className="stdiv">
            <div><img className="add" src={add}/>
            </div>
            <div className="prd">
             <span><strong>{prdName}</strong></span>
             <div className="prd__img">
                <img className="img1" src={img} />
            </div>
            <span><strong>{price}</strong></span>
            <div className="prd__star">
                <Star className="star"/>
                <Star className="star"/>
                <Star className="star"/>
                <Star className="star"/>
                <Halfstar className="star"/>
                
                <span className="prd__review"><strong>{review}</strong></span>
                
             
            </div>

            <span className="prd__cart"><button className='prd4__btn' onClick= {()=> dispatch({type: "ADD_TO_CART" , item: {id: id, img : img, prdName : prdName,reviews : review ,price : price,button:buttonCart }})} >Add to Cart</button></span>

            </div>
            
        </div>
    )
    

    
}